import * as actionTypes from './actionTypes';
import axios from '../../axios';
import i18n from "../../i18n";
import {API} from '../../constants';


export const setCommission = (commission) => {
    return {
        type: actionTypes.SET_COMMISSION,
        commission: commission
    };
};

export const setCommissionLoading = () => {
    return {
        type: actionTypes.FETCH_COMMISSION_STARTING,
    };
};

export const fetchCommissionFailed = (error) => {
    return {
        type: actionTypes.FETCH_COMMISSION_FAILED,
        error: error
    };
};

export const initCommission = (date) => {
    return dispatch => {
        // ${moment().format('YYYY/MM')}
        dispatch(setCommissionLoading());
        axios.get(`${API}${i18n.language}/affiliate/commission/${date}`)
            .then(response => {
                dispatch(setCommission(response.data));
            })
            .catch(error => {
                console.log('err', error);
                dispatch(fetchCommissionFailed(error));
            });
    };
};

export const setCommissionPlan = (data) => {
    return {
        type: actionTypes.SET_COMMISSION_PLAN,
        plan: data
    };
};

export const setCommissionPlanLoading = () => {
    return {
        type: actionTypes.FETCH_COMMISSION_PLAN_STARTING,
    };
};

export const fetchCommissionPlanFailed = () => {
    return {
        type: actionTypes.FETCH_COMMISSION_PLAN_FAILED
    };
};

export const setCommissionPerformance = (data) => {
    return {
        type: actionTypes.SET_COMMISSION_PERFORMANCE,
        total: data
    };
};

export const setCommissionPerformanceLoading = () => {
    return {
        type: actionTypes.FETCH_COMMISSION_PERFORMANCE_STARTING,
    };
};

export const fetchCommissionPerformanceFailed = () => {
    return {
        type: actionTypes.FETCH_COMMISSION_PERFORMANCE_FAILED
    };
};
export const getCommissionPlan = () => {
    return dispatch => {
        // ${moment().format('YYYY/MM')}
        dispatch(setCommissionPlanLoading());
        axios.get(`${API}${i18n.language}/affiliate/program`)
            .then(response => {
                dispatch(setCommissionPlan(response.data));
            })
            .catch(error => {
                console.log('err', error);
                dispatch(fetchCommissionPlanFailed());
            });
    };
};

export const getCommissionPerformance = () => {
    return dispatch => {
        // ${moment().format('YYYY/MM')}
        dispatch(setCommissionPerformanceLoading());
        axios.get(`${API}${i18n.language}/affiliate/performance`)
            .then(response => {
                dispatch(setCommissionPerformance(response.data));
            })
            .catch(error => {
                console.log('err', error);
                dispatch(fetchCommissionPerformanceFailed());
            });
    };
};
